import { ActionTabItem, NUGGET_VARIANTS, toolTransform } from '@backrs_ui/common-ui';

import { appStrings as commonAppStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { getBookmarkIdForNugget } from '@backrs_ui/grow-ui/src/pages/Bookmarks/pages/bookmarks.util';
import {
  useDeleteBookmarkMutation,
  useGetBookmarksQuery,
  usePostBookmarkMutation,
} from '@backrs_ui/grow-ui/src/redux/bookmarks/bookmarks.api';
import { useAppDispatch } from '@backrs_ui/grow-ui/src/redux/hooks';
import {
  openPlaylistListStep,
  setNuggetToAdd,
} from '@backrs_ui/grow-ui/src/redux/priorities/priorities.slice';
import { useGetToolByToolIdQuery } from '@backrs_ui/grow-ui/src/redux/tools/tools.api';
import { GROW_URL } from '@backrs_ui/grow-ui/src/settings';

const ACTION_STRINGS = commonAppStrings.modules.actionTabs;

export const useToolActions = (toolId: string, path: string, idPrefix: string) => {
  const dispatch = useAppDispatch();
  const { data: tool } = useGetToolByToolIdQuery(toolId);
  const { data: bookmarks } = useGetBookmarksQuery(undefined);
  const [postBookmark] = usePostBookmarkMutation();
  const [deleteBookmark] = useDeleteBookmarkMutation();
  const bookmarkId = getBookmarkIdForNugget(bookmarks, tool?.id, NUGGET_VARIANTS.TOOL);

  const actions: ActionTabItem[] = tool
    ? [
        {
          id: `${idPrefix}-bookmark-button`,
          icon: bookmarkId ? 'BookmarkCheck' : 'Bookmark',
          tooltipHoverText: ACTION_STRINGS.bookmark,
          onClick: () => {
            if (bookmarkId) deleteBookmark(bookmarkId);
            else postBookmark({ type: 'tool', itemId: tool.id });
          },
        },
        {
          id: `${idPrefix}-share-button`,
          icon: 'Share06',
          tooltipHoverText: ACTION_STRINGS.share,
          tooltipOnClickText: appStrings.modules.myColleges.linkCopied,
          tooltipPosition: 'top',
          onClick: () => navigator.clipboard.writeText(`${GROW_URL}${path}`),
        },
        {
          id: `${idPrefix}-add-task-button`,
          icon: 'ClipboardPlus',
          tooltipHoverText: ACTION_STRINGS.task,
          onClick: () => {
            dispatch(setNuggetToAdd(toolTransform(tool)));
            dispatch(openPlaylistListStep());
          },
        },
      ]
    : [];

  return actions;
};
